export const FETCH_SAVE_THERMIT_LOGIN_REQUEST = 'FETCH_SAVE_THERMIT_LOGIN_REQUEST'
export const FETCH_SAVE_THERMIT_LOGIN_SUCCESS = 'FETCH_SAVE_THERMIT_LOGIN_SUCCESS'
export const FETCH_SAVE_THERMIT_LOGIN_FALUIRE = 'FETCH_SAVE_THERMIT_LOGIN_FALUIRE'

